export const BLOG_ROOT = '/:sport/blog';
export const BLOG_CATEGORY = `${BLOG_ROOT}/category/:category`;
export const BLOG_POST = `${BLOG_ROOT}/:slug`;
export const BLOG_POST_PREVIEW = `${BLOG_ROOT}/p/:slug`;

export type BlogSport = 'football' | 'nba' | 'mlb';
